<div [ngClass]="['feedback', theme]" *ngIf="message" id="feedbackComponent">
  <div class="alert">
    <div class="container">
      <div class="message">
        <i></i> <strong> {{ message | translate }} </strong>
      </div>
    </div>
  </div>
</div>
